import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import { RecentPacketData } from '@/types';

// Define the expected API response structure (matches RecentPacketResult in backend)
interface RecentPacketAPIResponse {
  id: string;
  initials: string;
  candidateName: string;
  candidateTitle: string;
  status: string; // API might return status as string
  attempt?: number;
}

// Fetch function
const fetchRecentPackets = async (year?: string): Promise<RecentPacketData[]> => {
  const params = year ? { year } : undefined;
  const response = await get<RecentPacketAPIResponse[]>('/packets/recent', params);
  // Optional: Add any transformation needed from API response to RecentPacketData
  // For now, assuming the structure matches or is compatible
  return response as RecentPacketData[];
};

export const useRecentPackets = (year?: string) => {
  return useQuery<RecentPacketData[], Error>({
    queryKey: ['recentPackets', year],
    queryFn: () => fetchRecentPackets(year),
    // Optional: Configure stale time, cache time, etc.
    // staleTime: 5 * 60 * 1000, // 5 minutes
  });
}; 